<template>
  <div class="conditions">
    <h2 class="conditions__title">Condizioni principali</h2>

    <circle-list :items="conditions" />
  </div>
</template>

<script>
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'conditions',

    data() {
      return {
        // condizioni della gift card, uguali per tutti i prodotti (testi dal Figma)
        conditions: [
          {
            title: 'Utilizzo',
            text: 'La card è utilizzabile per tutte le prenotazioni sul servizio selezionato.',
          },
          {
            title: 'Validità',
            text: `Vale ${VALIDITY_MONTHS} mesi dalla data di acquisto.`,
          },
          {
            title: 'Rimborsabilità',
            text: `In linea con la normativa welfare, in caso di storno entro 20 giorni dall'acquisto, l'importo sarà riacreditato sul tuo conto welfare.`,
          },
          {
            title: 'Spendibilità',
            text: 'Spendibilità limitata al prodotto associato.',
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>

  .conditions {

    &__title {
      display: flex;
      align-items: center;
      margin: 0 0 $grid-gutter-width;
      font-size: 22px;
      font-weight: $vb-font-weight-semibold;
      color: $gray-900;
    }
  }
</style>